// extracted by mini-css-extract-plugin
export default {"comment-container":"comments_comment-container__13S66","comment-separator":"comments_comment-separator__IJkA-"};